export function nullSafe(obj, k0, k1, k2, k3, k4, k5) {
    let result = obj;
    const keysCount = arguments.length - 1;
    // tslint:disable-next-line:no-increment-decrement
    for (let i = 1; i <= keysCount; i++) {
        if (result === null || result === undefined) {
            return result;
        }
        result = result[arguments[i]];
    }
    return result;
}
export function notEmpty(value) {
    return value !== null && value !== undefined;
}
export function notEmptyString(value) {
    return notEmpty(value) && value !== '';
}
//# sourceMappingURL=nullSafe.js.map